<template>
  <nav :id="name" class="main-menu-content-list">
    <button
      v-for="mainMenuSlideModalFirstListItem in comMainMenuSlideModalFirst"
      :key="mainMenuSlideModalFirstListItem.type"
      class="main-menu-content-list-item"
      data-bs-dismiss="modal"
      @click.prevent="$router.push(`${mainMenuSlideModalFirstListItem.link}`)"
    >
      <i :class="`mc-${mainMenuSlideModalFirstListItem.icon}`"></i>
      <span>{{
        $t(
          `component.mainMenuSlideModal.${mainMenuSlideModalFirstListItem.type}`
        )
      }}</span>
    </button>
    <button
      v-for="mainMenuSlideModalSecondaryListItem in mainMenuSlideModalSecondary"
      :key="mainMenuSlideModalSecondaryListItem.type"
      class="main-menu-content-list-item"
      :class="user ? mainMenuSlideModalSecondaryListItem.type : ''"
      data-bs-dismiss="modal"
      @click.prevent="
        $router.push(`${mainMenuSlideModalSecondaryListItem.link}`)
      "
    >
      <i :class="`mc-${mainMenuSlideModalSecondaryListItem.icon}`"></i>
      <span>{{
        $t(
          `component.mainMenuSlideModal.${
            mainMenuSlideModalSecondaryListItem.type
          }`
        )
      }}</span>
    </button>
  </nav>
</template>

<script>
import { toCamelCase } from 'fe-common'
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useStore,
  watch
} from '@nuxtjs/composition-api'
import useComp from '../../../composables/useComp'
import useUser from '../../../composables/useUser'
import useLocale from '../../../composables/useLocale'
import useLogout from '../../../composables/useLogout'

export default defineComponent({
  name: 'MainMenuContent',
  props: {
    name: {
      type: String,
      default: 'MainMenuContent'
    },
    isUserPage: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const store = useStore()

    const { user } = useUser(context)
    const {
      compAgentLink,
      comMainMenuSlideModalFirst,
      comMainMenuSlideModalSecondary
    } = useComp()
    const { locale } = useLocale()
    const { logout } = useLogout(context)

    const isMobile = computed(() => store.state.isMobile)

    const mainMenuSlideModalSecondary = ref([])
    function mainMenuSlideModalSecondaryFn() {
      mainMenuSlideModalSecondary.value = comMainMenuSlideModalSecondary.value.filter(
        (item, idx, ary) => {
          return !user.value
            ? item.type !== 'user'
            : comMainMenuSlideModalSecondary.value
        }
      )
      console.log('!user.value', mainMenuSlideModalSecondary.value)
    }
    watch(user, () => {
      mainMenuSlideModalSecondaryFn()
    })
    onMounted(() => {
      mainMenuSlideModalSecondaryFn()
    })

    return {
      compAgentLink,
      comMainMenuSlideModalFirst,
      mainMenuSlideModalSecondary,
      locale,
      user,

      isMobile,
      toCamelCase,
      logout
    }
  }
})
</script>
